export default __webpack_public_path__ + "static/media/dizAllInONe.ed84c8c4.png";